<template>
    <div class="tests-public-page-container">
        <div id="tests-public-page" class="bulma col-10">
            <test-confirmation-modal />
            <test-error-modal/>
            <component
                :is="currentComponent"
                id="tests-container" class="column"
            ></component>
        </div>

        <p
            class="tests-public-page-description"
            v-html="trans.respondent_form.public_warning"
        ></p>
    </div>
</template>

<script>
import TestErrorModal from "../TestErrorModal";
import TestPageHeader from "../TestPageHeader";
import TestConfirmationModal from "../TestConfirmationModal";
import TestList from "../list/TestList";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "TestPublicForm",
    components: {TestErrorModal, TestPageHeader, TestConfirmationModal, TestList},
    props: {
        initTrans: Object,
        initRoutes: Object,
        test: Object,
        isAuth: Boolean,
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'currentComponent',
        ]),
    },
    mounted() {
        this.setTrans(this.initTrans);
        this.setRoutes(this.initRoutes);

        this.setIsAuth(this.isAuth);
        this.setIsPublicForm(true);
        this.showPublicTestForm(this.test);
    },
    methods: {
        ...mapActions('tests', [
            'setTrans',
            'setRoutes',
            'setIsPublicForm',
            'setIsAuth',
            'showPublicTestForm',
        ])
    },
}
</script>

<style scoped lang="scss">
.tests-public-page-container {
    max-width: 700px;
    width: 60%;
    align-self: center;
    @media (max-width: 768px) {
        width: 100%;
    }
}

.tests-public-page-description {
    font-size: 0.8rem;
    margin-top: 1rem;
    opacity: 0.85;
}

#tests-public-page {
    padding: 30px;
    width: 100%;
    border-radius: 10px;
    box-shadow: -2px 0px 8px -2px rgb(163 165 186);
}
</style>